module.exports = __webpack_public_path__ + "static/media/1.bcc722a5.jpg";